// [scheme:][//authority][path][?query]
// 协议：域名/参数
// 例如： com.qdxxzy.user://shihaoo.com?type=xxx

const CONFIG = {
	android: "http://mushroom.chumenwenwen.com/api/download?app=moyin&channel=android&version=latest",
	ios: "https://apps.apple.com/us/app/%E9%AD%94%E9%9F%B3%E5%B7%A5%E5%9D%8A/id1633046070",
	iosUrl: "com.qdxxzy.user://",
	androidUrl: 'moqi://com.mobvoi.moqi'
};

export default function openAppByBtn () {
	let oBtn = document.getElementById("openApp");
	oBtn.addEventListener("click", function () {
		//打开app整套流程
		openApp(goConfirmAddr);
	});
}

/**
 * 判断是否安装app
 * @url ios,android 提供（打开app的链接）
 * @callback （未安装app的回调）
 * */
function openApp(callback) {
	let { isAndroid, isIOS, isIOS9 } = judgePhoneType();
	if (isWeiXin()) {
		alert("请您点击右上角浏览器中打开,即可下载");
		return;
	}

	if (isAndroid) {
		let hasApp = true,
			t = 1000,
			t1 = Date.now(),
			ifr = document.createElement("iframe");

		setTimeout(function () {		
			if (!hasApp) {
				callback && callback();
			}
			document.body.removeChild(ifr);
		}, 2000);
		console.log('android',CONFIG.androidUrl);
		// window.open(CONFIG.androidUrl, '_blank')
		ifr.setAttribute("src", CONFIG.androidUrl);
		ifr.setAttribute("style", "display:none");
		document.body.appendChild(ifr);

		setTimeout(function () {
			//启动app时间较长处理
			let t2 = Date.now();
			if (t2 - t1 < t + 100) {
				hasApp = false;
			}
		}, t);
	}
	if(isIOS) {
			callback && callback();
	}
	if (isIOS9) {
		// location.href = url;
		setTimeout(function () {
			callback && callback();
		}, 250);
		setTimeout(function () {
			location.reload();
		}, 1000);
	}
}


/**
 * 超时跳转h5页面
 * */
function goConfirmAddr() {
	let { isAndroid } = judgePhoneType();
	window.location.href = !isAndroid ? CONFIG.ios : CONFIG.android;
}
/**
 * 判断是否为微信浏览器
 * 兼容ios
 * */
export function isWeiXin() {
	return (
		/micromessenger/i.test(navigator.userAgent.toLowerCase()) ||
		typeof (navigator as any).wxuserAgent !== "undefined"
	);
}
/**
 * 判断手机类型
 * return [ isAndroid, isIOS, isIOS9 ]
 * */
function judgePhoneType() {
	let isAndroid = false,
		isIOS = false,
		isIOS9 = false,
		version,
		u = navigator.userAgent,
		ua = u.toLowerCase();
	//Android系统
	if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
		//android终端或者uc浏览器
		isAndroid = true;
	}
	//ios
	if (ua.indexOf("like mac os x") > 0) {
		let regStr_saf = /os [\d._]*/gi;
		let verinfo = ua.match(regStr_saf);
		version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
	}
	let version_str = version + "";
	// ios9以上
	if (version_str !== "undefined" && version_str.length > 0) {
		version = parseInt(version);
		if (version >= 8) {
			isIOS9 = true;
		} else {
			isIOS = true;
		}
	}
	return { isAndroid, isIOS, isIOS9 };
}
